<template>
  <div>
    <div v-if="value" class="fixed top-0 left-0 w-full h-full z-modal bg-overlay" />
    <div v-if="value" class="fixed top-0 left-0 w-full h-full overflow-hidden z-modal">
      <div class="absolute top-0 left-0 flex flex-wrap items-center justify-center w-full h-full p-5 overflow-x-auto">
        <div class="relative w-full max-w-xl px-5 pt-8 pb-6 bg-white xl:py-10 xl:px-8">
          <div
            v-if="dismissable"
            class="absolute top-0 right-0 mt-4 mr-4 cursor-pointer"
            @click="$emit('input', false)"
          >
            <svg class="w-6" viewBox="0 0 19.8 19.8" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'w-4 h-4 transition-colors duration-300 ease-in-out fill-current text-sw_gray-600 hover:text-sw_primary_hover'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.001 17.678L17.68.001 19.8 2.12 2.123 19.8z"/><path d="M.001 2.122L2.123 0 19.8 17.678 17.68 19.8z"/></svg>
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Modal from '~brand-components/base/modal/modal.ts'

export default Modal.extend()
</script>
